<template>
  <section
    class="promotion-detail"
  >
    <div class="header">
      <h1>Product Promotion</h1>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules">
      <div class="flex border-box">
        <div class="half">
          <div class="form-item flex-align-center flex" >
            <el-switch
              v-model="formData.promotion_status"
              :active-value="1"
              :inactive-value="2"
              active-color="#409EFF"
              inactive-color="#AFB8C1"
            ></el-switch>
            <span class="mg-r-8 switch-text">Promotion <span
              class="gray-color"
              :class="{'blue-color':formData.promotion_status==1}">{{formData.promotion_status==1?'ON':'OFF'}}</span></span>
          </div>
          <div class="form-item">
            <el-form-item prop="company_id">
              <span>Insurer</span>
              <v-select
                v-model="formData.company_id"
                :list="insurerList"></v-select>
            </el-form-item>
          </div>
          <div class="form-item">
            <el-form-item>
              <span>Product</span>
              <v-select
                v-model="formData.class_id"
                :list="productOptionList"></v-select>
            </el-form-item>
          </div>
          <div class="form-item">
            <el-form-item>
              <span>Promotion Period</span>
              <v-date-picker
                v-model="formData.date"
                type="daterange"
              />
            </el-form-item>
          </div>
        </div>
      </div>
      <div class=" border-box">
        <div class="flex flex-align-center mg-b-20">
          <font-awesome-icon
            class="box-icon"
            icon="image"></font-awesome-icon>
          <span class="mg-l-8 box-title">Quick Quote Landing Page 1130x404</span>
        </div>
        <div class="flex">
          <div class="half">
            <el-form-item
              ref="data.en.cover_image_file_id"
              prop="data.en.cover_image_file_id"
              :rules="rules.img_upload">
              <span>Image (English)</span>
              <v-upload
                :card="true"
                :notUpload="true"
                :otherData="{
                  lang: 'en',
                  idKey:'cover_image_file_id',
                  urlKey:'cover_image_url'
                }"
                :fileData='{
                  thumb_url:fileData.en.cover_image_url
                }'
                @uploadForm="handlerUploadSuccess"
              />
            </el-form-item>
            <div class="flex">
              <!--              <span-->
              <!--                :class="[formData.type == 3 ? 'radio-circle-checked': 'radio-circle']"-->
              <!--                @click="changeType(3)"></span>-->
              <v-checkbox
                v-model="formData.mate.cover_type"
                :select-number="3"
                :isBoolean="false"
                class="mg-r-8"></v-checkbox>
              <el-form-item
                ref="mate.url_cover_en"
                prop="mate.url_cover_en"
                :rules='rules.cover_url'>
                <span>Destination URL (English)</span>
                <v-input
                  v-model="formData.mate.url_cover_en"
                  :disabled="formData.mate.cover_type!=3"></v-input>
              </el-form-item>
            </div>
          </div>
          <div class="half">
            <el-form-item
              ref="data.hk.cover_image_file_id"
              prop="data.hk.cover_image_file_id"
              :rules="rules.img_upload">
              <span>Image (Traditional Chinese)</span>
              <v-upload
                :card="true"
                :notUpload="true"
                :otherData="{
                  lang: 'hk',
                  idKey:'cover_image_file_id',
                  urlKey:'cover_image_url'
                }"
                :fileData='{
                  thumb_url:fileData.hk.cover_image_url
                }'
                @uploadForm="handlerUploadSuccess"
              />
            </el-form-item>
            <el-form-item
              ref="mate.url_cover_hk"
              prop="mate.url_cover_hk"
              :rules='rules.cover_url'>
              <span>Destination URL (Traditional Chinese)</span>
              <v-input
                v-model="formData.mate.url_cover_hk"
                :disabled="formData.mate.cover_type!=3"></v-input>
            </el-form-item>
          </div>
        </div>
      </div>
      <div class=" border-box">
        <div class="flex flex-align-center mg-b-20">
          <font-awesome-icon
            class="box-icon"
            icon="image"></font-awesome-icon>
          <span class="mg-l-8 box-title">Product Listing Page 1630x386</span>
        </div>
        <div class="flex">
          <div class="half">
            <el-form-item
              ref="data.en.hero_image_file_id"
              prop="data.en.hero_image_file_id"
              :rules="rules.img_upload">
              <span>Image (English)</span>
              <v-upload
                :card="true"
                :notUpload="true"
                :otherData="{
                  lang: 'en',
                  idKey:'hero_image_file_id',
                  urlKey:'hero_image_url'
                }"
                :fileData='{
                  thumb_url:fileData.en.hero_image_url
                }'
                @uploadForm="handlerUploadSuccess"
              />
            </el-form-item>
            <div class="flex">
              <v-checkbox
                v-model="formData.mate.hero_type"
                :select-number="3"
                :isBoolean="false"
                class="mg-r-8"></v-checkbox>
              <el-form-item
                ref="mate.url_hero_en"
                prop="mate.url_hero_en"
                :rules='rules.hero_url'>
                <span>Destination URL (English)</span>
                <v-input
                  v-model="formData.mate.url_hero_en"
                  :disabled="formData.mate.hero_type!=3"></v-input>
              </el-form-item>
            </div>

          </div>
          <div class="half">
            <el-form-item
              ref="data.hk.hero_image_file_id"
              prop="data.hk.hero_image_file_id"
              :rules="rules.img_upload">
              <span>Image (Traditional Chinese)</span>
              <v-upload
                :card="true"
                :notUpload="true"

                :otherData="{
                  lang: 'hk',
                  idKey:'hero_image_file_id',
                  urlKey:'hero_image_url'
                }"
                :fileData='{
                  thumb_url:fileData.hk.hero_image_url
                }'
                @uploadForm="handlerUploadSuccess"
              />
            </el-form-item>
            <el-form-item
              ref="mate.url_hero_hk"
              prop="mate.url_hero_hk"
              :rules='rules.hero_url'>
              <span>Destination URL (Traditional Chinese)</span>
              <v-input
                v-model="formData.mate.url_hero_hk"
                :disabled="formData.mate.hero_type!=3"></v-input>
            </el-form-item>
          </div>
        </div>
      </div>
      <div class="btn-group flex-sb">
        <v-button @click="handleCancel">Cancel</v-button>
        <div>
          <v-button
            v-if="promotionID"
            type="danger"
            @click="handleDel">Delete</v-button>
          <v-button
            type="success"
            @click="handleSave">Save</v-button>
        </div>
      </div>
    </el-form>
  </section>
</template>

<script>
import {couponOption, getUseCouponList} from '@/api/coupon'
import {uploadNewsImage,} from '@/api/news'
import {
  createPromotionProduct,
  deletePromotionProduct,
  getPromotionDetail,
  updatePromotionProduct
} from '@/api/promotion'
import MixinRules from '@/mixins/rules'
import MixinOptions from '@/mixins/options'

export default {
  name: 'proProductDetail',
  components:{
  },
  mixins: [MixinRules, MixinOptions],
  data () {
    const checkUrlRequired = (rule, value, callback) => {
      let {cover_type} = this.formData.meta||{}
      if(cover_type == 3){
        if(!value){
          callback(new Error(this.$t('placeholder.input')))
        }
      }
      callback()
    }
    const checkHeorUrlRequired = (rule, value, callback) => {
      let {hero_type} = this.formData.meta||{}
      if(hero_type == 3){
        if(!value){
          callback(new Error(this.$t('placeholder.input')))
        }
      }
      callback()
    }
    const checkCouponRequired = (rule, value, callback) => {
      if(this.formData.type == 4){
        if(!value){
          callback(new Error(this.$t('placeholder.select')))
        }
      }
      callback()
    }
    const checkProductRequired = (rule, value, callback) => {
      if(this.formData.type == 5){
        if(!value || value == -1){
          callback(new Error(this.$t('placeholder.select')))
        }
      }
      callback()
    }
    const checkImg = (rule, value, callback) => {
      if(!value){
        callback(new Error(this.$t('placeholder.upload')))
      }
      callback()
    }
    const checkTag = (rule, value, callback) => {
      if(!value.length){
        callback(new Error(this.$t('placeholder.select')))
      }
      callback()
    }
    return {
      fileData: {
        en: {},
        hk: {}
      },
      formData: {
        date: [],
        // private: 0,
        data:{
          en:{
            title: '',
            content: '',
            cover_image_file_id: '',
          },
          hk:{
            title: '',
            content: '',
            cover_image_file_id: '',
          },
        },
        start_date: '',
        end_date: '',
        mate:{
          url_cover_hk : '',
          url_cover_en : '',
          url_hero_hk :'',
          url_hero_en : '',
          cover_type:0,
          hero_type:0
        },
        promotion_status:0,
        company_id:'',
        class_id:'',
      },
      rules:{
        'img_upload': [
          {validator: checkImg}
        ],
        'tag': [
          {validator: checkTag}
        ],
        'title': [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        'content': [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        'date': [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        'cover_url':[
          {validator: checkUrlRequired, trigger: ['change', 'blur']}
        ],
        'hero_url':[
          {validator: checkHeorUrlRequired, trigger: ['change', 'blur']}
        ],
        'product':[
          {validator: checkProductRequired, trigger: ['change', 'blur']}
        ],
      },
      tags: [],
      timer: null
    }
  },
  computed:{
    isDetail(){
      return this.promotionDetail != null
    },
    promotionID(){
      return this.$route.query.promotion_id
    },
    insurerList(){
      let arr = [{
        id:0,
        name:'Non-Specific'
      }]
      return arr.concat(this.insurerAllOptions)||[]
    },
    productOptionList(){
      let {class_data=[]} = this.globalOptions||{}
      return class_data||[]
    }
  },
  async created(){
    // await  this.network().couponOption()
    if(this.promotionID){
      this.network().getPromotionDetail(this.promotionID)
    }
  },
  methods: {
    handlerUploadSuccess({ params, result, otherData }){
      this.network().uploadNewsImage({ params, result, otherData })
    },

    handleCancel(){
      this.$router.back()
    },
    handleDel(){
      this.network().deletePromotionProduct({promotion_id:this.promotionID})
    },
    handleSave(){
      this.$refs.form.validate((val, rule) => {
        if(val){
          let params = Object.assign({}, this.formData)
          params.start_date = params.date[0]
          params.end_date = params.date[1]
          params.category_type = 4
          delete params.date
          if(this.promotionID){
            this.network().updatePromotion({...params,promotion_id:this.promotionID})
          }else{
            this.network().newPromotion(params)
          }
        }else{
          this.scrollToValidDom(rule)
        }
      })
    },

    remoteMethod(query){
      let params = {
        search_text: query,
        hideLoading: true
      }
      if(this.timer){
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.network().getUseCouponList(params)
      }, 500)
    },
    handleFocus(){
      this.useCouponList = []
    },
    network(){
      return {
        getUseCouponList: async (params) => {
          let {data} = await getUseCouponList(params)
          this.useCouponList =data
        },

        couponOption: async () => {
          const {data} = await couponOption()
          this.productOptionList = data.insurance
        },

        newPromotion: async (params) => {
          const {data} = await createPromotionProduct( params)
          this.$message({
            type: 'success',
            message: 'Success'
          })
          if(data.promotion_id){
            this.$router.back()
          }
        },

        uploadNewsImage: async ({ params, result, otherData }) => {
          const { data } = await uploadNewsImage(params)
          const { lang,nameKey,idKey,urlKey } = otherData
          const { url } = result
          this.$set(this.formData.data[lang], idKey, data.image_id)
          this.$set(this.fileData[lang], urlKey, url)
          this.$message({
            type: 'success',
            message: 'Upload Success'
          })

          this.$refs['form'].clearValidate([`data.${lang}.${idKey}`])
        },

        getPromotionDetail: async (id) => {
          const { data } = await getPromotionDetail(id)
          // Object.assign(this.formData, data)
          let tmp = {
            data:{}
          }
          let {class_id,company_id,promotion_status,mate} = data||{}
          tmp.data.en = data.data[0]
          tmp.data.hk = data.data[1]

          this.formData.data = {}
          this.formData.data = tmp.data
          this.formData.date.push(data.start_date)
          this.formData.date.push(data.end_date)
          this.formData.class_id =class_id
          this.formData.company_id =company_id
          this.formData.promotion_status =promotion_status
          if(data.mate.url_cover){
            this.formData.mate.url_cover_en = data.mate.url_cover['en-US']
            this.formData.mate.url_cover_hk = data.mate.url_cover['zh-HK']
          }
          if(data.mate.url_hero){
            this.formData.mate.url_hero_en = data.mate.url_hero['en-US']
            this.formData.mate.url_hero_hk = data.mate.url_hero['zh-HK']
          }
          if(data.mate.cover_type)
          {
            this.formData.mate.cover_type = data.mate.cover_type

          }
          if(data.mate.hero_type)
          {
            this.formData.mate.hero_type = data.mate.hero_type
          }
          if(data.data[0])
            this.fileData.en = data.data[0]
          if(data.data[1])
            this.fileData.hk =  data.data[1]
        },

        updatePromotion: async (params) => {
          const {status} = await updatePromotionProduct( params)
          this.$message({
            type: 'success',
            message: 'Success'
          })
          if(status == 200){
            this.$router.back()
          }
        },
        deletePromotionProduct: async (params) => {
          const {status} = await deletePromotionProduct( params)
          this.$message({
            type: 'success',
            message: 'Success'
          })
          if(status == 200){
            this.$router.back()
          }
        },
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.icon{
  color:#409eff;
  cursor: pointer;
}
.clear:after{
  content: ' ';
  display: block;
  height: 0;
  clear: both;
}
.el-form-item{
  padding-bottom: 16px;
  span:first-child{
    display: block;
    padding-bottom: 5px;
    font-size: 14px;
    color: #24292E;
    font-family: Inter;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 17px;
  }
}
.promotion-detail{
  padding: 30px 70px;
  .radio-circle {
    display: inline-block;
    //   box-sizing: border-box;
    min-width: 14px;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    border: 1px solid #D5D8DE;
    background: white;
    cursor: pointer;
    margin-right: 10px;
  }
  .radio-circle-checked {
    position: relative;
    display: inline-block;
    //   box-sizing: border-box;
    min-width: 14px;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    background: #409eff;
    margin-right: 10px;
    &::before {
      position: absolute;
      content: '';
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 5px;
      height: 5px;
      border-radius: 100%;
      background: white;
    }
  }
  .border-box{
    padding-bottom: 16px;
    border-bottom: 1px solid #E1E4E8;
    margin-bottom: 31px;
    .mg-b-20{
      margin-bottom: 20px;
    }
    .box-title{
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #24292E;
      margin-left: 8px;
    }
    .box-icon{
      font-style: normal;
      font-weight: 900;
      font-size: 16px;
      line-height: 16px;
      color: #6A737D;
    }
    .switch-text{
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.15px;
      color: #24292E;
      display: block;
      margin-left: 8px;
      .gray-color{
        color: #959DA5!important;
      }
      .blue-color{
        color: #54AEF4!important;
      }
    }

    .half{
      //margin: 20px 30px;
      width: 350px;
      margin-right: 20px;
      /deep/ .el-switch{
        .el-switch__core{
          border-radius: 6px;
          border: 1px solid #AFB8C1;
          &:after{
            top: 0;
            border-radius: 6px;
            background: #F6F8FA;
            border: 1px solid #AFB8C1;
          }
          &:before{
            content: 'O';
            position: absolute;
            right: 5px;
          }
        }
        &.is-checked{
          .el-switch__core{
            border: 1px solid #54AEF4;
            &:after{
              background: #0366D6;
            }
            &:before{
              content: 'I';
              left: 10px;
              position: absolute;
            }
          }
        }

      }

      .classList{
        margin-top: 70px;
      }
      .flex{
        align-items: center;
        width: 100%;
        .el-form-item{
          width: 100%;
        }
        .flex-right{
          width: 100%;
          .el-select{
            width: 100%;
          }
        }
        .cb_tips{
          font-style: normal;
          font-family: Inter;
          font-weight: 600;
          font-size: 14px;
          line-height: 20px;
          color: #24292E;
          margin: 0px 8px;
          cursor: pointer;
        }
      }
    }
  }
}
.mg-r-8{
  margin-right: 8px;
}
</style>
